import Vue from 'vue'
import VueRouter from 'vue-router'
import { auth, onAuthStateChanged } from "./../resources/firebaseConfig";

Vue.use(VueRouter)

// Resolve the current user once and cache it — avoids re-registering
// onAuthStateChanged on every navigation (which can transiently return null
// while Firebase is still initialising and cause a false logout).
let currentUser = null;
let authResolved = false;

const authReady = new Promise((resolve) => {
  onAuthStateChanged(auth, (user) => {
    currentUser = user;
    if (!authResolved) {
      authResolved = true;
      resolve(user);
    }
  });
});

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '*', redirect: '/404' },
    {
      path: '/',
      name: 'Session',
      component: () => import('../views/Session.vue'),
      meta: { hideHeader: true, requiresAuth: false }
    },
    {
      path: '/404',
      name: '404',
      component: () => import('../views/404.vue'),
      meta: { hideHeader: true, requiresAuth: false }
    },
    {
      path: '/privacidad',
      name: 'privacidad',
      component: () => import('../views/privacidad.vue'),
      meta: { hideHeader: true, requiresAuth: false }
    },
    {
      path: '/Dashboard',
      name: 'Dashboard',
      component: () => import('../views/OnTheGo.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/Marcas',
      name: 'Marcas',
      component: () => import('../views/Marcas.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/Submarcas',
      name: 'Submarcas',
      component: () => import('../views/Submarcas.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/Modelos',
      name: 'Modelos',
      component: () => import('../views/Modelos.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/modelos/:id/estilos',
      name: 'Estilos',
      component: () => import('../views/estilos.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/Promociones',
      name: 'Promociones',
      component: () => import('../views/Promocion.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/Novedades',
      name: 'Novedades',
      component: () => import('../views/Novedades.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/Usuarios',
      name: 'Usuarios',
      component: () => import('../views/Usuarios.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/Sugerencias',
      name: 'Sugerencias',
      component: () => import('../views/Sugerencias.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/Aboutus',
      name: 'AboutUs',
      component: () => import('../views/aboutUs.vue'),
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  if (!requiresAuth) return next()
  // Wait for Firebase to resolve auth state (only blocks on first load)
  await authReady
  if (!currentUser) next('/')
  else next()
})

export default router
